import { CommonTextTranslation } from '../types/translation';
import { hasOwnProperty } from './utils';
import { BrandCommonText } from '../types/brand';

export function translateCommonTexts(
  commonText: BrandCommonText,
  translation?: CommonTextTranslation,
  lang?: string
) {
  if (!translation || !lang) return undefined;
  const { transforms: transforms } = translation;

  if (!transforms || !hasOwnProperty(transforms, lang) || !transforms[lang].active) {
    return undefined;
  }

  return {
    ...commonText,
    name: transforms[lang].delta.name,
    _lang: lang,
  };
}
